import { Component, OnInit, Input } from '@angular/core';
import { ComponentBase, UsedPartInfo } from 't4core';
import { FormControl } from '@angular/forms';
import { EntityEventInfo, EntityType } from 't4core';
import { start } from 'repl';

@Component({
  selector: 't4-used-parts',
  templateUrl: './usedparts.html',
  styleUrls: ['./usedparts.css']
})

export class T4UsedParts extends ComponentBase implements OnInit {
  public usedParts: UsedPartInfo[] = [];
  public filteredUsedParts: UsedPartInfo[] = [];
  public searchQuery: string = "";
  public isLoading: boolean = false;
  @Input() id: string = "";
  @Input() type: string = "";
  @Input() trailer: string = "";
  
  constructor() {
    super();
  }

  public async ngOnInit() {
    await this.loadData();
  }

  private async loadData() {
    this.isLoading = true;
    if (this.id != "" && this.type != "") {
      this.usedParts = await this.Api.get<UsedPartInfo[]>("/Service/GetUsedParts", { id: this.id, type: this.type });
      this.filteredUsedParts = this.usedParts;
    }
    this.isLoading = false;
  }

  public filterSearch(): void {
    this.filteredUsedParts = this.usedParts.filter(item =>
      item.ItemId.toLowerCase().includes(this.searchQuery.toLowerCase()));
    //this.currentPage = 1;
  }
}
